import { BaseApiService } from '@shared/services/BaseApiService';

class StatServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  getGeneral(params) {
    return this.http.get('/general', { params: params });
  }

  getDetailed(params) {
    return this.http.get('/detailed', { params: params });
  }
}

export const StatService = new StatServiceClass({
  api_version: 2,
  resource: 'stats/voice'
});
